<div>
I am {{ value === '021' ? "Australia" : "not Australia"}}
</div>
